import apiServices from '../../ApiServices/request-handler';
import { requestHandler } from '../../utils/functions';
import { getItem, setItem } from '../../utils/storage_services';
import { setToken } from '../../utils/utils';
import { setApplications, setApplicationsLoading, setAuthLoading, setEligibleAccounts, setEligibleAccountsLoading, setUsername } from '../slices/authSlice';
import { setLanguage } from '../slices/contentSlice';
import { resetInvestmentSlice } from '../slices/investmentsSlice';
import { onLogout, setRefreshTokenMetadata, setUserData } from '../slices/commonSlice';
import { setApplicantType, setClientApplicantId, setClientApplicationId, setClientId, setCompanyId, setIsCorporate, setRejectionMsg } from '../slices/constantSlice';
import { createCorpApplication } from './corporateAction';
import { getClientData } from './investmentsAction';

export const loginUser = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.login,
        param_data: data,
        isSuccessMessage: true,
        onDone: (data) => {
          onDone?.(data);
        },
      }),
    );
  };
};

export const verifyUserOtp = (param_data, navigate) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.verifyOtp,
        param_data: param_data,
        isSuccessMessage: true,
        onDone: (data) => {
          setToken(data?.result?.accessToken);
          dispatch(setClientId(data?.result?.clientId))
          const type_id = data?.result?.applicantTypeId;
          const is_corporate = data?.result?.investorTypeId === 2;
          const application_id = is_corporate ? data?.result?.corpClientApplicationId : data?.result?.clientApplicationId;
          if (type_id) {
            const type = type_id === 12 ? 'KSA Resident' : type_id === 11 ? 'KSA National' : type_id === 13 ? 'GCC National' : 'Other National';
            if (is_corporate) {
              dispatch(setIsCorporate(true));
              dispatch(setCompanyId(data?.result?.companyTypeId));
            } else {
              dispatch(setIsCorporate(false));
              dispatch(setApplicantType(type));
            }
          }
          dispatch(setRefreshTokenMetadata({
            refreshToken: data?.result?.refreshToken,
            epochExpiry: data?.result?.epochExpiry
          }));
          dispatch(setClientApplicationId(application_id));
          if (data?.result?.pendingApplications > 0) {
            navigate('/pending-applications', {
              replace: true,
              state: { data: { ...data?.result } },
            });
          } else {
            if (is_corporate) {
              dispatch(
                createCorpApplication(data?.result?.clientId, (res) => {
                  dispatch(setClientApplicationId(res?.result));
                  if (data?.result?.applicantTypeId?.toString() === '1067') {
                    navigate('/wathq-verification', {
                      replace: true,
                      state: {
                        data: {
                          clientId: data?.result?.clientId,
                          corpClientApplicationId: data?.result?.corpClientApplicationId,
                        }
                      }
                    });
                  } else {
                    navigate('/corporate-form', { replace: true });
                  }
                }),
              );
            } else navigate('/choose-applicant-type', { replace: true });
          }
        },
      }),
    );
  };
};

export const verifyLoginOtp = (param_data, navigate, isLogin = false) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.verifyLoginOtp,
        param_data: param_data,
        isSuccessMessage: true,
        onDone: (data) => {
          setToken(data?.result?.accessToken);
          dispatch(setRefreshTokenMetadata({
            refreshToken: data?.result?.refreshToken,
            epochExpiry: data?.result?.epochExpiry
          }));
          if (data?.result?.linkedAccounts?.length > 0) {
            navigate('/linked-accounts', {
              replace: true,
              state: { data: { ...data?.result } },
            });
          } else {
            navigate('/funds/available-funds', { replace: true });
            dispatch(setUserData({ ...data?.result }));
          }
        },
      }),
    );
  };
};

export const resendOtpCode = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.resendCode,
        param_data: data,
        isSuccessMessage: true,
        onDone,
      }),
    );
  };
};

export const forgetPassword = (data, navigate) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.forgetPassword,
        param_data: data,
        isSuccessMessage: true,
        onDone: (res) => {
          navigate('/otp', {
            state: { ...data, ...res?.result, isForgetPassword: true },
          });
        },
      }),
    );
  };
};

export const forgetUsername = (data, navigate) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.forgetUsername,
        param_data: data,
        isSuccessMessage: true,
        onDone: () => navigate('/otp', { state: { ...data, isUsername: true } }),
      }),
    );
  };
};

export const verifyForgetUsernameOtp = (data, navigate) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.verifyForgetUsernameOtp,
        param_data: data,
        isSuccessMessage: true,
        onDone: () => navigate('/login'),
      }),
    );
  };
};

export const verifyForgetOtp = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.verifyForgetOtp,
        param_data: data,
        isSuccessMessage: true,
        onDone,
      }),
    );
  };
};

export const getUserDetail = (user) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getUserInfo,
        onDone: async (data) => {
          dispatch(setUserData({ ...user, ...data?.result }));
          dispatch(
            setLanguage({
              language: data?.result?.clientLanguage?.languageName,
            }),
          );
          dispatch(getClientData());
        },
      }),
    );
  };
};

export const resetPassword = (data, navigate) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.resetPassword,
        setLoading: setAuthLoading,
        param_data: data,
        isSuccessMessage: true,
        onDone: () => navigate('/login'),
      }),
    );
  };
};

export const register = (data) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.register,
        param_data: data,
        isSuccessMessage: true,
        onDone: async (data) => {
          // setToken(data?.token);
          // saveUser(data?.data);
          // dispatch(setUser(data?.data))
          // await loginKey(true);
          // resetNavigationStack('Tabs');
        },
      }),
    );
  };
};

export const logoutUser = (onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.logout,
        // param_data: data,
        setLoading: setAuthLoading,
        onDone: async () => {
          const tempUsername = getItem("username");
          dispatch(onLogout());
          localStorage.clear();
          setToken('');
          dispatch(setUsername(tempUsername ?? null));
          dispatch(setRefreshTokenMetadata(null));
          dispatch(resetInvestmentSlice());
          setItem("username", tempUsername);
          dispatch(setApplicantType(null));
          dispatch(setClientApplicationId(null));
          dispatch(setClientApplicantId(null));
          dispatch(setClientId(null));
          dispatch(setRejectionMsg(null));
          // window.location.href = "/#/login";
          window.location.href = "/#/funds/available-funds";
          onDone && onDone();
        }
      })
    )
  };
};

export const onlineAccess = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.onlineAccess,
        param_data: data,
        setLoading: setAuthLoading,
        onDone: (val) => onDone(val?.result),
      }),
    );
  };
};

export const updateClient = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.updateClient,
        param_data: data,
        setLoading: setAuthLoading,
        onDone: (val) => onDone(val),
      }),
    );
  };
};

export const generateOnlineAccessOtp = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.generateOnlineAccessOtp,
        param_data: data,
        setLoading: setAuthLoading,
        onDone: (val) => onDone && onDone(val),
        isSuccessMessage: true,
      }),
    );
  };
};

export const verifyOnlineAccessOtp = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.verifyOnlineAccessOtp,
        param_data: data,
        setLoading: setAuthLoading,
        onDone: (data) => onDone(data),
      }),
    );
  };
};

export const getApplications = () => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setApplicationsLoading,
        apiService: apiServices.getApplications,
        setData: setApplications,
      }),
    );
  };
};

export const postActivateAccount = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.postActivateAccount,
        param_data: data,
        isSuccessMessage: true,
        onDone: (res) => onDone && onDone(res),
      }),
    );
  };
};

export const postActivateAccountOtp = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.postActivateAccountOtp,
        param_data: data,
        isSuccessMessage: true,
        onDone: (res) => onDone && onDone(res),
      }),
    );
  };
};


export const postResendClientCredentialsEmail = (data, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.postResendClientCredentialsEmail,
        param_data: data,
        isSuccessMessage: true,
        onDone: (res) => onDone && onDone(res),
      }),
    );
  };
};

export const selectAccounts = (params, onDone) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        param_data: params,
        apiService: apiServices.selectAccounts,
        onDone: (data) => {
          setToken(data?.result?.accessToken);
          dispatch(setRefreshTokenMetadata({
            refreshToken: data?.result?.refreshToken,
            epochExpiry: data?.result?.epochExpiry
          }));
          dispatch(setUserData(data?.result));
          onDone && onDone(data);
        },
      }),
    );
  };
};